import { useEffect } from 'react';
import '../../../res/lcslog';
import { getRegionFromCookie } from '~/__modules__/browser';
import ENV from '~/__modules__/env';

window.lcs_SerName = ENV.LCS_SERVER_NAME;
const PREFIX = 'worksmobile';

export function useLCS(stiName) {
  useEffect(() => {
    lcs(stiName);
  }, []);
}

export function lcs(stiName, region = getRegionFromCookie()) {
  if (!window.lcs_SerName || !stiName) return;
  if (!region) return;

  const sti = `${PREFIX}_${stiName}_${region.replace(/[0-9]/g, '')}`;
  window.lcs_do({ sti });
  console.log('NDS LCS sti:', sti);
}
